import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import ivclass from '../../Modules/IVClass';
const HeaderItemIcon = (props) => {
    const { icon, className = 'iv-pr-10' } = props;
    return (_jsx(React.Fragment, { children: icon && (_jsx("div", { className: ivclass('iv-flex', className), children: _jsx("img", { src: icon.url, alt: icon.alt, width: icon.width, height: icon.height }) })) }));
};
export default HeaderItemIcon;
